






















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class DoKoViewLastTrick extends Vue {
  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get transformText() {
    return `translate(${this.x} ${this.y})`;
  }
}
